export enum ActivityType {
  CustomerRemoving = 'CustomerRemoving',

  CustomerReplacing = 'CustomerReplacing',

  CustomerOrderResumed = 'CustomerOrderResumed',

  FundTransferTransactionClosing = 'FundTransferTransactionClosing',

  OpenDrawer = 'OpenDrawer',

  BlindPickup = 'BlindPickup',

  PriceModify = 'PriceModify',

  TillDeclaration = 'TillDeclaration',

  TillClosing = 'TillClosing',

  EnterTrainingMode = 'EnterTrainingMode',

  Reprint = 'Reprint',

  TenderLoan = 'TenderLoan',

  TenderPickup = 'TenderPickup',

  ItemTaxExempt = 'ItemTaxExempt',

  TaxExempt = 'TaxExempt',

  TaxReverse = 'TaxReverse',

  FuelPriceUpdate = 'FuelPriceUpdate',

  PaidIn = 'PaidIn',

  PaidOut = 'PaidOut',

  RemoveLoyaltyCard = 'RemoveLoyaltyCard',

  SwitchLoyaltyCard = 'SwitchLoyaltyCard',

  RecallTransaction = 'RecallTransaction',

  RecallSelfScanTransaction = 'RecallSelfScanTransaction',

  RecallUnpaidTransaction = 'RecallUnpaidTransaction',

  ReverseEligibility = 'ReverseEligibility',

  ReturnItem = 'ReturnItem',

  ReturnAll = 'ReturnAll',

  ReturnTransaction = 'ReturnTransaction',

  TransactionBasedReturn = 'TransactionBasedReturn',

  DepartmentSale = 'DepartmentSale',

  DepartmentReturn = 'DepartmentReturn',

  ApplyAccessorialFee = 'ApplyAccessorialFee',

  SearchMobileOrderByLoyalty = 'SearchMobileOrderByLoyalty',

  BottleDepositReturn = 'BottleDepositReturn',
}
